import { Fade, useTheme } from '@volkswagen-onehub/components-core';
import React from 'react';

type Props = {
  children: React.ReactNode;
  startAnimation: boolean;
  delay?: number;
};

export const AnimatedFade = ({
  children,
  startAnimation,
  delay,
}: Props): React.ReactElement | null => {
  const { size } = useTheme();

  return startAnimation ? (
    <Fade distance={size.static300} directionFrom="bottom" delay={delay} duration={500}>
      {children}
    </Fade>
  ) : null;
};
